import { ActionType } from "../../../../react-core/Flux/ActionType";
import { JsonDateParser } from "../../../../react-core/Utils/JsonDateParser";
import { AdviserChargeReportClient } from "../../../../Wrap/Api/Reports/BusinessManagement/AdviserCharge/AdviserChargeReport";
import { PortfolioInvestmentReportClient } from "../../../../Wrap/Api/Reports/Investment/PortfolioInvestmentReport";
import { PerformanceSummaryReportClient } from "../../../../Wrap/Api/Reports/Performance/PerformanceSummaryReport";
import { CashTransactionReportClient } from "../../../../Wrap/Api/Reports/Transaction/CashTransactionReport";
import { InvestmentTransactionReportClient } from "../../../../Wrap/Api/Reports/Transaction/InvestmentTransactionReport";
import { TaskRequestStatusClient } from "../../../../Wrap/Api/Tasks/TaskRequestStatus";
import { AssetClassType } from "../../../../Wrap/Constants/Enums/Domain/Instrument/AssetClassType";
import { PerformanceMethod } from "../../../../Wrap/Constants/Enums/Domain/PerformanceMethod";
import { ServiceProposition } from "../../../../Wrap/Constants/Enums/ServiceProposition";
import { SortDirection } from "../../../../Wrap/Core/SortingAndPaging/SortDirection";
import { ViewType } from "../../../../Wrap/Mapping/PortfolioAnalysis/Investment/Enum/ViewType";
import { CashTransactionTypes } from "../../../../Wrap/Models/Domains/Transactions/Cash/CashTransactionTypes";
import { AdviserChargeReport } from "../../../../Wrap/Models/Models/AdviserCharges/AdviserChargeReport";
import { ExcelExportDispatcher } from "../Store/Variable";

export class ExcelExportAction {
    public static generatePerformanceSummaryReport(
        hierarchyIds: Array<string>,
        toDate: Date,
        fromDate: Date,
        fromInception: boolean,
        returnBasis: PerformanceMethod,
        customerId: number,
        consolidateHeadAccountHierarchyId: string
    ): void {
        const selectFromDate = JsonDateParser.toJsonDateNoOffset(fromDate);
        const selectToDate = JsonDateParser.toJsonDateNoOffset(toDate);
        const client = new PerformanceSummaryReportClient();
        const promise = client.post(
            hierarchyIds,
            selectFromDate,
            selectToDate,
            fromInception,
            returnBasis,
            customerId,
            consolidateHeadAccountHierarchyId
        );
        promise.onSuccess((res) => {
            ExcelExportDispatcher.dispatch({ actionType: ActionType.Success, payload: res });
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    public static generateInvestmentTransactionReport(
        hierarchyId: string,
        fromDate: Date,
        toDate: Date,
        cNoteId: number,
        instrumentCode: string,
        transSource: string,
        sortName: string,
        sortDirection: string,
        modelId: number
    ): void {
        const client = new InvestmentTransactionReportClient();
        const promise = client.post(
            hierarchyId,
            modelId,
            JsonDateParser.toJsonDateNoOffset(fromDate),
            JsonDateParser.toJsonDateNoOffset(toDate),
            transSource,
            instrumentCode,
            cNoteId,
            sortName,
            sortDirection
        );
        promise.onSuccess((res) => {
            ExcelExportDispatcher.dispatch({ actionType: ActionType.Success, payload: res });
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    public static generateInvestmentReport(
        hierarchyIds: string[],
        asAt: Date,
        assetClassType: AssetClassType,
        viewType: ViewType,
        drillDownModelList: Array<number>,
        actorId: number
    ): void {
        const client = new PortfolioInvestmentReportClient();
        const promise = client.post(
            hierarchyIds,
            assetClassType,
            JsonDateParser.toJsonDateNoOffset(asAt),
            viewType,
            drillDownModelList,
            actorId
        );
        promise.onSuccess((res) => {
            ExcelExportDispatcher.dispatch({ actionType: ActionType.Success, payload: res });
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    public static generateCashTransactionReport(
        hierarchyId: string,
        fromDate: Date,
        toDate: Date,
        fromInception: boolean,
        movementType: CashTransactionTypes,
        modelId: number,
        sortDirection: SortDirection
    ) {
        const client = new CashTransactionReportClient();
        const promise = client.post(
            hierarchyId,
            JsonDateParser.toJsonDateNoOffset(fromDate),
            JsonDateParser.toJsonDateNoOffset(toDate),
            fromInception,
            movementType,
            modelId,
            0,
            0,
            sortDirection
        );
        promise.onSuccess((res) => {
            ExcelExportDispatcher.dispatch({ actionType: ActionType.Success, payload: res });
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    public static generateAdviserChargeReport(
        companyHierarchyId: string,
        adviserHierarchyId: string,
        fromDate: Date,
        toDate: Date,
        servicePropositions: ServiceProposition[]
    ): void {
        const client = new AdviserChargeReportClient();
        const request: AdviserChargeReport = {
            CompanyHierarchyId: companyHierarchyId,
            AdviserHierarchyId: adviserHierarchyId,
            FromDate: JsonDateParser.toJsonDateNoOffset(fromDate),
            ToDate: JsonDateParser.toJsonDateNoOffset(toDate),
            ServicePropositions: servicePropositions,
        };
        const promise = client.post(request);
        promise.onSuccess((res) => {
            ExcelExportDispatcher.dispatch({ actionType: ActionType.Success, payload: res });
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    public static getTaskRequestStatus(taskRequestId: string, callback?): void {
        const client = new TaskRequestStatusClient();
        const promise = client.get(taskRequestId);
        promise.onSuccess((res) => {
            if (callback) {callback(res);}
            ExcelExportDispatcher.dispatch({ actionType: ActionType.Update, payload: res.Status });
        });
        promise.onError((err) => {
            console.log(err);
        });
    }
}
